import { monitor } from '../tools/monitor';
import { getZoneJsOriginalValue } from '../tools/getZoneJsOriginalValue';
import { addTelemetryDebug } from '../domain/telemetry';
/**
 * Add an event listener to an event target object (Window, Element, mock object...).  This provides
 * a few conveniences compared to using `element.addEventListener` directly:
 *
 * * supports IE11 by: using an option object only if needed and emulating the `once` option
 *
 * * wraps the listener with a `monitor` function
 *
 * * returns a `stop` function to remove the listener
 */
export function addEventListener(eventTarget, event, listener, options) {
    return addEventListeners(eventTarget, [event], listener, options);
}
/**
 * Add event listeners to an event target object (Window, Element, mock object...).  This provides
 * a few conveniences compared to using `element.addEventListener` directly:
 *
 * * supports IE11 by: using an option object only if needed and emulating the `once` option
 *
 * * wraps the listener with a `monitor` function
 *
 * * returns a `stop` function to remove the listener
 *
 * * with `once: true`, the listener will be called at most once, even if different events are listened
 */
export function addEventListeners(eventTarget, events, listener, _a) {
    var _b = _a === void 0 ? {} : _a, once = _b.once, capture = _b.capture, passive = _b.passive;
    var wrappedListener = monitor(function (event) {
        if (once) {
            stop();
        }
        reportUntrustedEvent(event);
        listener(event);
    });
    var options = passive ? { capture: capture, passive: passive } : capture;
    var add = getZoneJsOriginalValue(eventTarget, 'addEventListener');
    events.forEach(function (event) { return add.call(eventTarget, event, wrappedListener, options); });
    function stop() {
        var remove = getZoneJsOriginalValue(eventTarget, 'removeEventListener');
        events.forEach(function (event) { return remove.call(eventTarget, event, wrappedListener, options); });
    }
    return {
        stop: stop,
    };
}
var reportedUntrustedEventTypes = new Set();
function reportUntrustedEvent(event) {
    var eventType = event.type;
    if (event.isTrusted || window.jasmine || reportedUntrustedEventTypes.has(eventType)) {
        return;
    }
    reportedUntrustedEventTypes.add(eventType);
    addTelemetryDebug('Untrusted event', { event_type: eventType });
}
export function resetUntrustedEventsCount() {
    reportedUntrustedEventTypes.clear();
}
//# sourceMappingURL=addEventListener.js.map